export const getCustomerNameFromFilterModel = (filterModel) => {
    const item = (filterModel?.items ?? []).find((filter) => filter.field === '_related_legalEntity_name');
    if (item?.value == null || item.value === '') {
        return null;
    }

    if (Array.isArray(item.value)) {
        const values = item.value.map((value) => String(value).trim()).filter(Boolean);
        return values.length > 0 ? values.join(', ') : null;
    }

    const normalized = String(item.value).trim();
    return normalized || null;
};
